module.exports = __webpack_public_path__ + "static/demo-1-31bce10f2cd35457db6cfaa0ab9a513a.jpg";